import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useT } from '../i18n/I18nContext';
import config from '../config/config';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [serverUrl, setServerUrl] = useState(localStorage.getItem('serverUrl') || config.defaultServerUrl);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { login, loading, error } = useContext(AuthContext);
  const { t } = useT();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');

    if (!email || !password) {
      setErrorMessage(t('login.enterAll'));
      return;
    }

    if (!serverUrl) {
      setErrorMessage(t('login.enterServer'));
      return;
    }

    const success = await login(email, password, serverUrl);
    if (success) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="auth-page page-shell">
      <div className="container">
        <div className="auth-shell">
          <section className="auth-intro">
            <span className="section-eyebrow">{t('login.eyebrow')}</span>
            <h1>{t('login.heading')}</h1>
            <p>
              {t('login.body')}
            </p>
            <div className="auth-benefits">
              <div className="auth-benefit-card">
                <strong>{t('login.benefit1Heading')}</strong>
                <span>{t('login.benefit1Body')}</span>
              </div>
              <div className="auth-benefit-card">
                <strong>{t('login.benefit2Heading')}</strong>
                <span>{t('login.benefit2Body')}</span>
              </div>
            </div>
          </section>

          <section className="auth-form-panel">
            <div className="auth-form">
              <div className="auth-form-header">
                <h2>{t('login.formHeading')}</h2>
                <p>{t('login.formBody')}</p>
              </div>

              {(error || errorMessage) && (
                <div className="alert alert-danger">
                  {errorMessage || error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">{t('login.email')}</label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">{t('login.password')}</label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    required
                  />
                </div>

                {config.features.collapsibleServerUrl ? (
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn-link advanced-toggle"
                      onClick={() => setShowAdvanced(current => !current)}
                    >
                      {showAdvanced ? t('login.advancedHide') : t('login.advancedShow')}
                    </button>

                    {showAdvanced && (
                      <div className="advanced-settings">
                        <label htmlFor="server-url">{t('login.serverURL')}</label>
                        <input
                          type="url"
                          id="server-url"
                          className="form-control"
                          value={serverUrl}
                          onChange={(event) => setServerUrl(event.target.value)}
                          placeholder={config.defaultServerUrl}
                          required
                        />
                        <small className="form-text">{t('login.serverHelp')}</small>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="form-group">
                    <label htmlFor="server-url">{t('login.serverURL')}</label>
                    <input
                      type="url"
                      id="server-url"
                      className="form-control"
                      value={serverUrl}
                      onChange={(event) => setServerUrl(event.target.value)}
                      placeholder={config.defaultServerUrl}
                      required
                    />
                    <small className="form-text">{t('login.serverHelp')}</small>
                  </div>
                )}

                <div className="form-actions">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? t('login.loading') : t('login.btn')}
                  </button>
                  <Link to="/register" className="auth-link">
                    {t('login.noAccount')}
                  </Link>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Login;
